import { useDetailApi } from "../../../swr/useApi";
import type { ProductWarrantyDto } from "../../../api";
import { productWarrantiesService } from "../../api_client";

export function useProductWarranty(id?: number | null) {
    return useDetailApi<ProductWarrantyDto>({
        key: `product-warranty-${id ?? "none"}`,
        serviceMethod: async () =>
            await productWarrantiesService.getProductWarrantyById(id as number),
        options: {
            isPaused: () => !id,
        },
    });
}
